import styled from 'styled-components'
import ArticleCard from '../ArticleCard'


const QuadGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 15vh);

    background: #C6BCAB;

    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-size: 48px;

    border: 1px solid black;
    line-height: 13vh;

    .THE {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
        font-size: 35px;
    }
    .Q {
        grid-row: 2;
        grid-column: 1;
        border: inherit;
                border-bottom: 0px solid black;

    }
    .U {
        grid-row: 2;
        grid-column: 2;
        border: inherit;
                border-bottom: 0px solid black;

    }
    .A {
        grid-row: 2;
        grid-column: 3;
        border: inherit;
                border-bottom: 0px solid black;

    }
    .D {
        grid-row: 2;
        grid-column: 4;
        border: inherit;
                border-bottom: 0px solid black;

    }
    .Blank1 {
        grid-row: 1;
        grid-column: 2;
        border: inherit;

    }
    .Blank2 {
        grid-row: 1;
        grid-column: 3;
        border: inherit;

    }

    .Blank3 {
        grid-row: 1;
        grid-column: 4;
        border: inherit;

`;

const ArticleGrid = styled("div")`
    background: #C6BCAB;
`

const QuadMobile = (props) => {
    let quad = props.quad;
    let a1 = quad[0];
    let a2 = quad[1];
    let a3 = quad[2];
    return (
        <>
            <QuadGrid>
                <div class="THE">THE</div>
                <div class="Q">Q</div>
                <div class="U">U</div>
                <div class="A">A</div>
                <div class="D">D</div>

                <div class="Blank1"></div>
                <div class="Blank2"></div>
                <div class="Blank3"></div>

            </QuadGrid>

            <ArticleGrid>
                <div class="A1">
                    <ArticleCard
                        position='right'
                        article_title={a1.article_title}
                        article_byline={a1.article_byline}
                        article_image={a1.article_image} article_url={a1.article_url}></ArticleCard>
                </div>
                <div class="A2">
                    <ArticleCard
                        position='left'
                        article_title={a2.article_title}
                        article_byline={a2.article_byline}
                        article_image={a2.article_image} article_url={a2.article_url}></ArticleCard>
                </div>
                <div class="A3">
                    <ArticleCard
                        position='right'
                        article_title={a3.article_title}
                        article_byline={a3.article_byline}
                        article_image={a3.article_image} article_url={a3.article_url}></ArticleCard>
                </div>
                {/* <div class="A4">
                    <ArticleCard
                        position='left'
                        article_title={a4.article_title}
                        article_byline={a4.article_byline}
                        article_image={a4.article_image} article_url={a4.article_url}></ArticleCard>
                </div> */}

            </ArticleGrid>

        </>
    )
}

export default QuadMobile;